import axios from "axios";
import { custId, masterId, masterPassword, proxyAPI } from "../secrets";
import { hash } from "../format";
import { creditUserTypes } from '../types';

export const addCreditUser = async (userData: creditUserTypes.CreditUser) => {
    if (!masterId || !masterPassword || !proxyAPI) return;
    console.log({
        masterId,
        masterPassword,
        proxyAPI,
    })
    try {    
        const user_pwd = hash.formatCreditPassword(userData.password);
        const cv_pwd = hash.formatCreditPassword(masterPassword);

        const xmlString =  `
            <?xml version="1.0" encoding="utf-8"?> 
            <data_area> 
                <header_data> 
                    <user_id>${masterId}</user_id> 
                    <user_pwd>${cv_pwd}</user_pwd> 
                    <cus_id>${custId}</cus_id> 
                    <action>ADD_USER</action> 
                </header_data> 
                <user_data> 
                    <ip>${userData.ip}</ip> 
                    <name>${userData.name}</name> 
                    <uid>${userData.uid.substring(0,15)}</uid> 
                    <user_pwd>${user_pwd}</user_pwd> 
                    <email>${userData.email}</email> 
                </user_data> 
            </data_area>  
        `
        
        const result = await axios.post(`${proxyAPI}/add-user`, xmlString, {
            headers:   {
                'Content-Type': 'text/xml; charset=utf-8'
            }
        }); 
        
        return result.data;
    } catch (error) {
        throw error;
    }
}

export const changeCreditPassword = async (userData: { uid: string, cus_id: string }, prevPassword: string, newPassword: string) => { 
    if (!userData.cus_id || !proxyAPI) return;
    console.log({prevPassword})
    try {    
        const user_pwd = hash.formatCreditPassword(prevPassword);
        const new_pwd = hash.formatCreditPassword(newPassword);
 
        const xmlString = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
            <data_area> 
                <header_data> 
                    <user_id>${userData.uid}</user_id> 
                    <user_pwd>${user_pwd}</user_pwd> 
                    <new_pwd>${new_pwd}</new_pwd> 
                    <cus_id>${userData.cus_id}</cus_id> 
                    <action>PWD_CHANGE</action>
                    <xml_format>1</xml_format>
                    <single_joint>0</single_joint>
                    <lookback>0</lookback>
                </header_data> 
            </data_area> 
        `
  
        const result = await axios.post(`${proxyAPI}/change-password`, xmlString, {
            headers: {
                'Accept': 'text/xml',
                'Content-Type': 'text/xml; charset=utf-8',
            }
        }); 
        
        return result;
    } catch (error) {
        return error;
    }
}